import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Infinity as InfinityIcon } from "lucide-react";

/** Exchanges the Emergent Google session_id in the URL fragment for a portal session. */
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        nav("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        setErr(formatApiErrorDetail(e?.response?.data?.detail) || e.message);
      }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6" data-testid="auth-callback">
      <div className="text-center max-w-sm">
        <InfinityIcon className="h-9 w-9 text-[#156F5B] mx-auto" strokeWidth={2.5} />
        {err ? (
          <>
            <div className="mt-5 text-sm text-red-700 rounded-md border border-red-200 bg-red-50 px-4 py-3" data-testid="auth-callback-error">
              {err}
            </div>
            <button onClick={() => nav("/login", { replace: true })} className="k-btn-outline mt-5" data-testid="auth-callback-back">
              Back to sign in
            </button>
          </>
        ) : (
          <p className="mt-5 k-sublabel">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
